import { Flex, Select, useToast } from "@chakra-ui/react";
import axios from "axios";
import Cookies from "js-cookie";
import { useEffect, useRef, useState } from "react";
import { CircleFlag } from "react-circle-flags";
import G2Promotion from "../../assets/images/promotions/G2PromotionalBanner.svg";
import { industryTypes } from "../../data/industryTypes";
import useCheckLimit from "../../hooks/useCheckLimit";
import useKeyGenerate from "../../hooks/useKeyGenerate";
import Button from "../Button/Button";
import DocPage from "../DocPage/DocPage";
import Rating from "../Rating/Rating";
import { SelectMenu } from "../SelectMenu";
import { TextBox } from "../TextBox";
import CSS from "./styles.module.css";
const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;

const IslandContainer = ({ resultVal, limitSet }) => {
	// ChakraUI Toast
	const toast = useToast();

	// Refs
	const jTitleBox = useRef(null);
	const jCompanyBox = useRef(null);
	const jIndustryBox = useRef(null);

	// Generated Results logic
	const [result, setResult] = useState(0);
	const limitExceeded = useCheckLimit();

	// Job Description
	const [JDdata, setJDdata] = useState("");

	// Form Data & thier handlers
	const [JTitle, setJTitle] = useState("");
	const [CName, setCName] = useState("");
	const [IndType, setIndType] = useState("");
	const [lang, setLang] = useState("Eng (US)");

	const keyword = useKeyGenerate();

	const jTitleHandler = (e) => {
		setJTitle(e.currentTarget.value);
	};

	const cNameHandler = (e) => {
		setCName(e.currentTarget.value);
	};

	const indTypeHandler = (e) => {
		setIndType(e.currentTarget.value);
	};

	const langChangeHandler = (e) => {
		if (e !== "") {
			setLang(`${e}`);
		}
	};

	const increaseLimitCount = () => {
		let count = Cookies.get("genCount");
		if (!count) {
			Cookies.set("genCount", "1", {
				expires: 1,
			});
		} else {
			count = parseInt(count) + 1;
			Cookies.set("genCount", count.toString(), {
				expires: 1,
			});
		}
	};

	// API Call
	const fetchResult = async () => {
		if (!limitExceeded) {
			if (JTitle !== "") {
				const job_title = `${JTitle}. Generate JD in ${lang} Language only.`;
				const job_company = `${CName}`;
				const job_industry = `${IndType}`;

				setJDdata("");

				setResult(1);

				increaseLimitCount();

				setTimeout(() => {
					setResult(2);
				}, 100);

				const header = {
					Authorization: `Bearer ${keyword}`,
				};

				await axios
					.post(
						API_ENDPOINT,
						{
							job_title,
							job_company,
							job_industry,
						},
						{ headers: header }
					)
					.then((res) => {
						if (res && res.data && res.data.choices) {
							setJDdata(res.data.choices[0].message.content);
						}

						setTimeout(() => {
							setResult(3);
						}, 100);
					})
					.catch((err) => {
						console.error(err);
						setTimeout(() => {
							setResult(2);
							setTimeout(() => {
								setResult(1);
							}, 100);
							toast({
								title: "Oops!",
								description: "Something went wrong. Try again.",
								status: "error",
								duration: 5000,
								isClosable: true,
								position: "bottom-left",
							});
						}, 53000);
					});
			} else {
				toast({
					description: "Please fill out Job Title field. (Required)",
					status: "error",
					duration: 5000,
					isClosable: true,
					position: "bottom-left",
				});
			}
		} else {
			limitSet(true);
		}
	};

	useEffect(() => {
		resultVal(result);
	}, [result, resultVal]);

	useEffect(() => {
		setTimeout(() => {
			jTitleBox.current.focus();
		}, 1500);
	}, []);

	useEffect(() => {
		setJTitle(jTitleBox.current.value);
		setCName(jCompanyBox.current.value);
		setIndType(jIndustryBox.current.value);
	}, [jTitleBox.current, jCompanyBox.current, jIndustryBox.current]);

	return (
		<Flex
			alignItems="center"
			flexDirection="column"
			width="100%"
			style={{ position: "relative", padding: "0px 15px" }}
		>
			<div
				className={`${CSS.IslandContainer} ${
					result === 3 ? CSS.IC_expanded : ""
				}`}
			>
				<div
					className={`${CSS.InputGrid} ${result === 2 ? CSS.IG_Progress : ""}`}
				>
					<TextBox
						placeholder="Job Title"
						className={CSS.JTInput}
						onChange={jTitleHandler}
						ref={jTitleBox}
						required
						wide
					/>
					<TextBox
						placeholder="Company Name"
						onChange={cNameHandler}
						ref={jCompanyBox}
						optionalLabel
						wide
					/>
					<Select
						variant="filled"
						placeholder="Industry Type (Optional)"
						height="50px"
						onChange={indTypeHandler}
						ref={jIndustryBox}
						required
					>
						{industryTypes.map((Industry, index) => (
							<option key={index} value={Industry}>
								{Industry}
							</option>
						))}
					</Select>

					<SelectMenu
						placeholder="Language"
						id="languageSelect"
						defaultValue={lang}
						onChange={langChangeHandler}
						className={CSS.LangSelect}
						optionalLabel
					>
						<span>
							<CircleFlag countryCode="us" /> Eng (US)
						</span>
						<span>
							<CircleFlag countryCode="uk" /> Eng (UK)
						</span>
						<span>
							<CircleFlag countryCode="es" /> Spanish
						</span>
						<span>
							<CircleFlag countryCode="de" /> German
						</span>
						<span>
							<CircleFlag countryCode="fr" /> French
						</span>
						<span>
							<CircleFlag countryCode="it" /> Italian
						</span>
						<span>
							<CircleFlag countryCode="sa" /> Arabic
						</span>
						<span>
							<CircleFlag countryCode="nl" /> Dutch
						</span>
						<span>
							<CircleFlag countryCode="pt" /> Portugese
						</span>
						<span>
							<CircleFlag countryCode="pl" /> Polish
						</span>
					</SelectMenu>

					<Button
						variant="HeroButton"
						className={CSS.HeroButton}
						leftIcon="bolt"
						onClick={fetchResult}
						disabled={
							result === 3 || result === 1 || result === 0 ? false : true
						}
					>
						{result === 2
							? "Generating..."
							: result === 3
							? "Regenerate"
							: "Generate JD"}
					</Button>
				</div>

				<div
					className={`${CSS.Results} ${
						result === 2 ? CSS.ResultsInprogress : ""
					} ${result === 3 ? CSS.ResultsComplete : ""} ${
						result === 0 ? CSS.ResultsHidden : ""
					}`}
				>
					<div className={CSS.IconIllustration}>
						<div className={CSS.ProcessingIcon}>
							<div className={`${CSS.Sparkles} ${CSS.Sparkle1}`}></div>
							<div className={`${CSS.Sparkles} ${CSS.Sparkle2}`}></div>
							<div className={`${CSS.Sparkles} ${CSS.Sparkle3}`}></div>
						</div>
						<div className={CSS.Steps}>
							<div className={CSS.step}></div>
							<div className={CSS.step}></div>
							<div className={CSS.step}></div>
						</div>
					</div>

					<font>
						Generating your top-class Job Description. It may take upto 10
						seconds.
					</font>
				</div>

				{result === 3 && (
					<div className={CSS.PromotionBanner}>
						<a
							href="https://dash.recooty.com/register?referral=ultra&http_referer=https%3A%2F%2Fdash.recooty.com%2F"
							target="_blank"
						>
							<img
								src={G2Promotion}
								alt="Free Job description Generator Banner Ad"
							/>
						</a>
					</div>
				)}

				<DocPage isActive={result === 3}>{JDdata}</DocPage>
			</div>
			<div className={CSS.HighlightPoints}>
				<div className={CSS.Point}>
					<span className="material-symbols-outlined">task_alt</span>
					SEO-Optimized
				</div>
				<div className={CSS.Separator}></div>
				<div className={CSS.Point}>
					<span className="material-symbols-outlined">task_alt</span>
					Time Saving
				</div>
				<div className={CSS.Separator}></div>
				<div className={CSS.Point}>
					<span className="material-symbols-outlined">task_alt</span>
					3x More Reach
				</div>
			</div>
			<Rating
				comment={
					<font>
						Recooty's AI job description generator has saved our tons of hours
						while creating perfect job descriptions.
						<br />
						It is so easy for us now to create a great job description for any
						role in seconds.
					</font>
				}
				person="Anna Heslin"
				company="Recruiter"
				className={`${CSS.Rating} ${
					result === 0 ? CSS.RatingInit : CSS.RatingOff
				}`}
			/>
		</Flex>
	);
};

export default IslandContainer;
